import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Compiler, CompilerFactory, COMPILER_OPTIONS, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { JitCompilerFactory } from '@angular/platform-browser-dynamic';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { BusyModule } from 'angular2-busy';
import { DataTableModule } from "angular2-datatable";
import { DataTablesModule } from 'angular-datatables';
import { ModalModule } from 'angular2-modal';
import { BootstrapModalModule } from 'angular2-modal/plugins/bootstrap';
import { MomentModule } from 'angular2-moment';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { SignaturePadModule } from 'angular2-signaturepad';
import { TextMaskModule } from 'angular2-text-mask';
import { MyDatePickerModule } from 'mydatepicker';
import { ClipboardModule } from 'ngx-clipboard';
import { ColorPickerModule } from 'ngx-color-picker';
import { ToastrModule } from 'ngx-toastr';
import { DataFilterPipe } from './data-filter.pipe';
import { Helper } from './helpers/helper';
import { PellModule } from 'angular-pell';
export function createCompiler(compilerFactory: CompilerFactory) {
	return compilerFactory.createCompiler();
  }


import { AppRoutingModule } from './/app-routing.module';
import { AccountComponent } from './account/account.component';
import { ActivefreetrialComponent } from './activefreetrial/activefreetrial.component';
import { FreetrialtoactiveComponent } from './activefreetrial/freetrialtoactive.component';
import { ActivitylogComponent } from './activitylog/activitylog.component';
import { AdmininvoiceComponent } from './admininvoice/admininvoice.component';
import { AppComponent } from './app.component';
import { Constants } from './app.constants';
import { AuthGuard } from './auth-guard';
import { LoginauthService } from './loginauth.service'; // login auth
import { AutologoutService } from './autologout.service';
import { CreateChequeComponent } from './create-cheque/create-cheque.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AddechexadminComponent } from './echexadmin/addechexadmin.component';
import { EchexadminComponent } from './echexadmin/echexadmin.component';
import { EchexbaseComponent } from './echexbase/echexbase.component';
import { AddechexmerchantComponent } from './echexmerchant/addechexmerchant.component';
import { EchexmerchantComponent } from './echexmerchant/echexmerchant.component';
import { EditechexmerchantComponent } from './echexmerchant/editechexmerchant.component';
import { EchexpaymentService } from './echexpayment.service';
import { CreateemailtemplateComponent } from './emailtemplates/createemailtemplate.component';
import { EditemailtemplateComponent } from './emailtemplates/editemailtemplate.component';
import { EmailtemplatesComponent } from './emailtemplates/emailtemplates.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { BankauthUrlComponent } from './generate-bankauth-url/bankauth-url.component';
import { GenerateBankauthUrlComponent } from './generate-bankauth-url/generate-bankauth-url.component';
import { ThankYouLinkComponent } from './generate-bankauth-url/thank-you-link.component';
import { CheckoutUrlComponent } from './generate-checkout-url/checkout-url.component';
import { GenerateCheckoutUrlComponent } from './generate-checkout-url/generate-checkout-url.component';
import { GlobalEventMangerService } from './global-event-manger.service';
import { InvoiceComponent } from './invoice/invoice.component';
import { ViewinvoiceComponent } from './invoice/viewinvoice.component';
import { LocalstorageService } from './localstorage.service';
import { LoginComponent } from './login/login.component';
import { ManagepermissionsComponent } from './managepermissions/managepermissions.component';
import { MerchantusermanagepermissionsComponent } from './managepermissions/merchantusermanagepermissions.component';
import { MenuitemsComponent } from './menuitems/menuitems.component';
import { PermissionAddComponent } from './permission/permission-add.component';
import { PermissionEditComponent } from './permission/permission-edit.component';
import { PermissionComponent } from './permission/permission.component';
import { CreateplanComponent } from './plan/createplan.component';
import { EditplanComponent } from './plan/editplan.component';
import { PlanComponent } from './plan/plan.component';
import { ProfileComponent } from './profile/profile.component';
import { RegisterComponent } from './register/register.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { ScriptService } from './script.service';
import { SendcheckComponent } from './sendcheck/sendcheck.component';
import { SendcheckprintedComponent } from './sendcheck/sendcheckprinted.component';
import { WanttoprintsendcheckComponent } from './sendcheck/wanttoprintsendcheck.component';
import { SetpasswordComponent } from './setpassword/setpassword.component';
import { CreatestatusComponent } from './status/createstatus.component';
import { EditstatusComponent } from './status/editstatus.component';
import { StatusComponent } from './status/status.component';
import { TabComponent } from './tab/tab.component';
import { TabsComponent } from './tab/tabs.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { EditTransactionsComponent } from './transactions/edittransactions.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { UserService } from './user.service';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { LoginAuthenticationComponent } from './login-authentication/login-authentication.component';
import { PackageComponent } from './package/package.component';
import { CasherpayUsersComponent } from './casherpay-users/casherpay-users.component';
import { CreateInvoiceComponent } from './create-invoice/create-invoice.component';

import { AmountValidatorDirective } from './amount-validator.directive';
import { PayInvoiceComponent } from './pay-invoice/pay-invoice.component';
import { InvoiceBankauthComponent } from './invoice-bankauth/invoice-bankauth.component';
import { InvoiceSecureauthComponent } from './invoice-secureauth/invoice-secureauth.component';
import { MinValueDirectiveDirective } from './min-value-directive.directive';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { PreventEDirective } from './prevent-e.directive';
import { AdjustFontSizeDirective } from './adjust-font-size.directive';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { EditechexmerchantuserComponent } from './editechexmerchantuser/editechexmerchantuser.component';
import { AddCustomplanComponent } from './account/addcustomplan.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
	MenuitemsComponent,
    DashboardComponent,
    RegisterComponent,
    ActivefreetrialComponent,
    FreetrialtoactiveComponent,
    SetpasswordComponent,
    ForgotpasswordComponent,
    ProfileComponent,
    AccountComponent,
    ResetpasswordComponent,
    ThankyouComponent,
    TabComponent,
	TabsComponent,
	EchexadminComponent,
	AddechexadminComponent,
	EchexmerchantComponent,
	AddechexmerchantComponent,
	EditechexmerchantComponent,
	DataFilterPipe,
	PermissionComponent,
	PermissionAddComponent,
	PermissionEditComponent,
	ManagepermissionsComponent,
	MerchantusermanagepermissionsComponent,
	InvoiceComponent,
	ViewinvoiceComponent,
	AdmininvoiceComponent,
	EchexbaseComponent,
	ActivitylogComponent,
	StatusComponent,
	CreatestatusComponent,
	EditstatusComponent,
	EmailtemplatesComponent,
	CreateemailtemplateComponent,
	EditemailtemplateComponent,
	PlanComponent,
	CreateplanComponent,
	EditplanComponent,
	SendcheckComponent,
	WanttoprintsendcheckComponent,
	SendcheckprintedComponent,
	GenerateCheckoutUrlComponent,
	GenerateBankauthUrlComponent,
	BankauthUrlComponent,
	CheckoutUrlComponent,
	ThankYouLinkComponent,
	CreateChequeComponent,
	TransactionsComponent,
	EditTransactionsComponent,
	VerifyEmailComponent,
	LoginAuthenticationComponent,
	PackageComponent,
	CasherpayUsersComponent,
	AmountValidatorDirective,
	CreateInvoiceComponent,
	PayInvoiceComponent,
	InvoiceBankauthComponent,
	InvoiceSecureauthComponent,
	MinValueDirectiveDirective,
	TextEditorComponent,
	AdjustFontSizeDirective,
	PreventEDirective,
	PagenotfoundComponent,
	EditechexmerchantuserComponent,
	AddCustomplanComponent,
  ],
  imports: [
    BrowserModule,
	HttpClientModule,
	FormsModule,
	NgbModule.forRoot(),
	AppRoutingModule,
	BrowserAnimationsModule,
    BusyModule,
	ModalModule.forRoot(),
	BootstrapModalModule,
	TextMaskModule,
	SignaturePadModule,
	DataTableModule,
	DataTablesModule,
	FroalaEditorModule.forRoot(), 
	FroalaViewModule.forRoot(),
	ColorPickerModule,
	ClipboardModule,
	ReCaptchaModule,
	MyDatePickerModule,
	HttpModule,
	MomentModule,
    NgIdleKeepaliveModule.forRoot(),
	ToastrModule.forRoot(),
	PellModule 
  ],
  providers: [
	UserService,
	AutologoutService,
	Constants,
	AuthGuard,
	LoginauthService,
	GlobalEventMangerService,
	EchexpaymentService,
	Helper,
	LocalstorageService,
	ScriptService,
	{provide: LocationStrategy, useClass: HashLocationStrategy},
	{provide: COMPILER_OPTIONS, useValue: {}, multi: true},
    {provide: CompilerFactory, useClass: JitCompilerFactory, deps: [COMPILER_OPTIONS]},
    {provide: Compiler, useFactory: createCompiler, deps: [CompilerFactory]},
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/app.module.ts